var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"user",class:_vm.classNames},[_vm._v(_vm._s(_vm.name)),(_vm.showLoginOutBtn)?_c('span',{staticClass:"user__out",on:{"click":_vm.loginOut}},[_vm._v("退出")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }